import { render, staticRenderFns } from "./GuppyWhatsappChatBox.vue?vue&type=template&id=9a02c88c&scoped=true"
import script from "./GuppyWhatsappChatBox.vue?vue&type=script&lang=js"
export * from "./GuppyWhatsappChatBox.vue?vue&type=script&lang=js"
import style0 from "./GuppyWhatsappChatBox.vue?vue&type=style&index=0&id=9a02c88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a02c88c",
  null
  
)

export default component.exports